const emoTextList = [
    "微笑",
    "撇嘴",
    "色",
    "发呆",
    "流泪",
    "害羞",
    "闭嘴",
    "睡",
    "大哭",
    "尴尬",
    "发怒",
    "调皮",
    "呲牙",
    "惊讶",
    "难过",
    "囧",
    "抓狂",
    "吐",
    "偷笑",
    "愉快",
    "白眼",
    "傲慢",
    "困",
    "惊恐",
    "憨笑",
    "悠闲",
    "咒骂",
    "疑问",
    "嘘",
    "晕",
    "衰",
    "骷髅",
    "敲打",
    "再见",
    "擦汗",
    "抠鼻",
    "鼓掌",
    "坏笑",
    "右哼哼",
    "鄙视",
    "委屈",
    "快哭了",
    "阴险",
    "亲亲",
    "可怜",
    "笑脸",
    "生病",
    "脸红",
    "破涕为笑",
    "恐惧",
    "失望",
    "无语",
    "嘿哈",
    "捂脸",
    "奸笑",
    "机智",
    "皱眉",
    "吃瓜",
    "加油",
    "汗",
    "天啊",
    "Emm",
    "社会",
    "旺柴",
    "好的",
    "打脸",
    "哇",
    "翻白眼",
    "666",
    "让我看看",
    "叹气",
    "苦涩",
    "裂开",
    "嘴唇",
    "爱心",
    "心碎",
    "拥抱",
    "强",
    "弱",
    "握手",
    "胜利",
    "抱拳",
    "勾引",
    "拳头",
    "OK",
    "合十",
    "啤酒",
    "咖啡",
    "蛋糕",
    "鲜花",
    "凋谢",
    "菜刀",
    "炸弹",
    "便便",
    "晚安",
    "太阳",
    "庆祝",
    "礼物",
    "红包",
    "發",
    "福",
    "烟花",
    "爆竹",
    "猪头",
    "跳跳",
    "发抖",
    "转圈",
];
let transform = (content, extClass) => {
    return content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, (text) =>
        textToImg(text, extClass)
    );
};

// 将匹配结果替换表情图片
let textToImg = (emoText, extClass) => {
    let word = emoText.replace(/\#|\;/gi, "");
    let idx = emoTextList.indexOf(word);
    if (idx == -1) {
        return emoText;
    }
    let url = require(`@/assets/emoji/${word}.png`);
    return `<img src="${url}" class="${extClass}" />`;
};

let textToUrl = (emoText) => {
    let word = emoText.replace(/\#|\;/gi, "");
    let idx = emoTextList.indexOf(word);
    if (idx == -1) {
        return "";
    }
    let url = require(`@/assets/emoji/${word}.png`);
    return url;
};

export default {
    emoTextList,
    transform,
    textToImg,
    textToUrl,
};